import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import { DayFlag } from '../DayFlag/DayFlag'
import { useWeekday } from '../../hooks/useWeekday'
import type { OpeningHourItem } from '../../types/openingHours.types'

export type OpeningHourProps = {
	openingHour: OpeningHourItem
	menuOptions: Option[]
}

export const OpeningHour = ({ openingHour, menuOptions }: OpeningHourProps) => {
	const { t } = useTranslation()
	const getWeekday = useWeekday()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{openingHour.date}</p>
				<ContextMenu
					item={openingHour}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: openingHour.date })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail
					label={t('Open')}
					value={<DayFlag value={openingHour.is_open} label={t('Open')} />}
				/>
				<Detail
					label={t('Bookable')}
					value={<DayFlag value={openingHour.is_bookable} label={t('Bookable')} />}
				/>
				<Detail
					label={t('Counted in duration')}
					value={
						<DayFlag value={openingHour.counts_towards_duration} label={t('Counted in duration')} />
					}
				/>
				<Detail label={t('Weekday')} value={getWeekday(openingHour.date)} />
				<Detail label={t('Holiday')} value={openingHour.is_holiday || '—'} />
				<Detail label={t('Reason')} value={openingHour.reason || '—'} />
			</dl>
		</li>
	)
}
